export const ADMIN_REQUESTS_PAGE_SIZE = 10;

/** UI column keys used by table headers. */
export type AdminRequestSortKey =
  | "applicant"
  | "business"
  | "type"
  | "environment"
  | "volume"
  | "status"
  | "submitted";

export type AdminRequestSortDir = "asc" | "desc";

/** API `sort` query values (whitelist on the server). */
export type AdminRequestApiSortKey =
  | "created_at"
  | "contact_name"
  | "company_name"
  | "requester_type"
  | "environment"
  | "status"
  | "expected_daily_volume";

const UI_TO_API_SORT: Record<AdminRequestSortKey, AdminRequestApiSortKey> = {
  applicant: "contact_name",
  business: "company_name",
  type: "requester_type",
  environment: "environment",
  volume: "expected_daily_volume",
  status: "status",
  submitted: "created_at",
};

export function adminRequestSortToApi(
  key: AdminRequestSortKey,
): AdminRequestApiSortKey {
  return UI_TO_API_SORT[key];
}

export function adminRequestsPageCount(
  total: number,
  pageSize: number = ADMIN_REQUESTS_PAGE_SIZE,
): number {
  return Math.max(1, Math.ceil(total / pageSize));
}

export function adminResultRangeLabel(
  total: number,
  page: number,
  pageSize: number = ADMIN_REQUESTS_PAGE_SIZE,
): string {
  if (total === 0) {
    return "Showing 0 requests";
  }
  const start = (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, total);
  if (start === end) {
    return `Showing ${start} of ${total}`;
  }
  return `Showing ${start}–${end} of ${total}`;
}

/** Stable label for sort headers / aria. */
export function adminSortColumnLabel(key: AdminRequestSortKey): string {
  switch (key) {
    case "applicant":
      return "Applicant";
    case "business":
      return "Business";
    case "type":
      return "Type";
    case "environment":
      return "Environment";
    case "volume":
      return "Volume / day";
    case "status":
      return "Status";
    case "submitted":
      return "Submitted";
    default:
      return key;
  }
}
